function generalMessagePopUpShow(title = "", text = "", callback) {
  document.getElementById("general_message_title").innerText = title || "Oops, something went wrong";
  document.getElementById("general_message_text").innerText = text || "Please try again later!!!";
  var closeButton = document.getElementById("general_message_modal_close_btn");
  if (closeButton && callback) {
    closeButton.addEventListener("click", callback);
  }
  $(general_message_modal).modal("show");
}

function generalMessagePopUpHide(callback = () => {}) {
  $(general_message_modal).modal("hide");
  document.getElementById("general_message_title").innerText = "";
  document.getElementById("general_message_text").innerText = "";
  var closeButton = document.getElementById("general_message_modal_close_btn");
  closeButton.addEventListener("click", () => {});
  callback();
}

function takeRefreshUserDataandLoadDashboardPage(data) {
  console.log("This is the takeRefreshUserDataandLoadDashboardPage");
  let payment_plans = JSON.parse(sessionStorage["payment_plans"]);
  let geo = sessionStorage["geo_country_selected"];
  let paymentPlansGeoObj = new PaymentPlans().getPaymentPlansBasedonGeo(geo);

  let payment_geo_selected = sessionStorage["geo_country_selected"];
  console.log("AJAX to hit refresh_user ");
  console.log("This is the AJAX response ", data);
  var google_auth_status =
    data?.user?.google_auth_status == true
      ? `<span style="font-size:12pt;padding-inline: 10px; background-color:rgb(27 176 73); color:white; border-radius:5px; padding-block:5px">Connected</span>`
      : `<span style="font-size:11pt;padding-inline: 10px; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding-block:5px">pending</span>`;
  if (typeof data != "string") {
    let plan_data = data["user"]["plan"];

    if (plan_data["plan"] == "plan_0") {
      let current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Free</span>';
      let date_next_renewal = "-"; //plan_data['date_next_renewal']
      let api_key_section = "";
      let credits_topup_section = "";
    } else if (plan_data["plan"] == "plan_1") {
      let current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Startup</span>';
      let date_next_renewal = plan_data["date_next_renewal"];
      // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
      let credits_topup_section = document
        .getElementById("credits_topup_section_element")
        .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
        .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
        .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
        .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
        .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
        .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
        .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
        .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
        .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
        .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
        .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
    } else if (plan_data["plan"] == "plan_2") {
      let current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">Small Business</span>';
      let date_next_renewal = plan_data["date_next_renewal"];
      try {
        // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
      } catch {
        // api_key_section = localStorage['user']
      }

      let credits_topup_section = document
        .getElementById("credits_topup_section_element")
        .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
        .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
        .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
        .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
        .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
        .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
        .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
        .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
        .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
        .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
        .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
    } else if (plan_data["plan"] == "plan_3") {
      let current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">' + "Enterprise" + "</span>";
      let date_next_renewal = plan_data["date_next_renewal"];
      // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
      let credits_topup_section = document
        .getElementById("credits_topup_section_element")
        .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
        .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
        .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
        .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
        .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
        .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
        .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
        .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
        .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
        .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
        .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
    } else {
      let current_plan_label = '<span style="font-size:11pt; background-color:rgb(91, 192, 222); color:white; border-radius:5px; padding:3px">' + "Custom Plan" + "</span>";
      let date_next_renewal = plan_data["date_next_renewal"];
      // api_key_section = document.getElementById("api_key_section_element").innerHTML.replace(/{api_key}/g, JSON.parse(localStorage['user'])['_id'])
      let credits_topup_section = document
        .getElementById("credits_topup_section_element")
        .innerHTML.replaceAll("{credits_1}", paymentPlansGeoObj["credits_1_credits"])
        .replaceAll("{credits_2}", paymentPlansGeoObj["credits_2_credits"])
        .replaceAll("{credits_3}", paymentPlansGeoObj["credits_3_credits"])
        .replaceAll("{credits_4}", paymentPlansGeoObj["credits_4_credits"])
        .replaceAll("{credits_5}", paymentPlansGeoObj["credits_5_credits"])
        .replaceAll("{credits_1_price}", paymentPlansGeoObj["credits_1_price"])
        .replaceAll("{credits_2_price}", paymentPlansGeoObj["credits_2_price"])
        .replaceAll("{credits_3_price}", paymentPlansGeoObj["credits_3_price"])
        .replaceAll("{credits_4_price}", paymentPlansGeoObj["credits_4_price"])
        .replaceAll("{credits_5_price}", paymentPlansGeoObj["credits_5_price"])
        .replaceAll("{credits_symbol}", paymentPlansGeoObj["currency_symbol"]);
    }

    let total_credits_avalable = plan_data["credits"];
    try {
      let num_people_referred = plan_data["people_referred"].length;
    } catch {
      let num_people_referred = 0;
    }
    let num_people_referred_label = "users referred";
    document.getElementById("all_content").innerHTML = document
      .getElementById("dashboard_page_element")
      .innerHTML.replace(/{screen_height}/g, height)
      .replace(/{email}/g, localStorage["email"])
      .replace(/{current_plan_label}/g, current_plan_label)
      .replace(/{google_auth_status}/g, google_auth_status)
      .replace(/{date_next_renewal}/g, date_next_renewal)
      .replace(/{total_credits_avalable}/g, total_credits_avalable)
      .replace(/{num_people_referred}/g, num_people_referred)
      .replace(/{num_people_referred_label}/g, num_people_referred_label)
      // .replace(/{api_key_section}/g, api_key_section)
      .replace(/{credits_topup_section}/g, credits_topup_section);

    document.getElementById("pricing_payment_section").innerHTML = document.getElementById("pricing_payment_data").innerHTML;
    new PaymentPlans().setDashboardPrices();
    initialiseFunctionRangeSliderValue();
    if (plan_data["plan"] == "plan_0") {
      document.getElementById("button_plan0").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
    } else if (plan_data["plan"] == "plan_1") {
      document.getElementById("button_plan1").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
    } else if (plan_data["plan"] == "plan_2") {
      document.getElementById("button_plan2").innerHTML = '<div class="small_button_white" style="display:inline-block; width:110px">Current plan</div><br><span style="cursor:pointer; color:grey" onclick="cancelPlan()">Cancel</span><br><br>';
    }
    new UtilityFunctions().activateToolTips();
    // $('[data-toggle="tooltip"]').tooltip({
    //         placement : 'top'
    //     });
  } else {
    new PageContents().changePage("/#");
  }
  console.log(data.user);
  localStorage["user"] = JSON.stringify(data.user);
  new PageContents().setLogonStatus();
}

function loadCandidateSourcesPages() {
  document.getElementById("right_search_results_people_companies_orgcharts").innerHTML = document.getElementById("job_portals_data_fetch").innerHTML;
  document.getElementById("current_account_name").innerText = "panda Jobs 1234";
}

function contactDetailsReplaceElement() {
  let blank_phone_number = "+x xxx-  •••••••";
  let blank_email_row = "•••••••  @xxxx.com";
}

class Components {
  get_input_value_by_id(id) {
    var element = document.getElementById(id);
    if (element && element.tagName.toLowerCase() === "input") {
      return element.value;
    } else {
      console.log("Element with ID '" + id + "' is not an input element or does not exist.");
      return null;
    }
  }

  clear_input_value_by_id(id) {
    document.getElementById(id).value = "";
  }

  set_dropdown_menu(selectedItem) {
    let chipText = selectedItem.textContent;
    let btn = selectedItem.parentElement.parentElement.parentElement.querySelector("button");
    btn.setAttribute("data-selected", chipText);
    btn.querySelector("div").textContent = chipText;
    this.addChipInUIbyId("selected_option_chips", chipText);
    let id = btn.getAttribute("id");
    if (id && id == "custom_gpt_process_btn") {
      new UtilityFunctions().get_gpt_cost_by_token(chipText);
    }
  }

  addChipInUIbyId(eleId, chipText) {
    console.log("Got to add chip in UI by iud::", eleId, chipText);
    if (!this.isChipExists(eleId, chipText)) {
      console.log("Chip doenst exist");
      let selected_option_ele = document.getElementById(eleId);
      let chip = this.getChip(eleId, chipText);
      // document.getElementById("token_text_"+chipText+"-class-name-"+unique_val).style.borderRight = "block"
      let selected_option = selected_option_ele.innerHTML;
      selected_option += chip;
      selected_option_ele.innerHTML = selected_option;
    }
  }

  removeChipInUIbyId(eleId, chipText) {
    console.log("Got to remove chip in UI by iud::", eleId, chipText);
    let selected_option_ele = document.getElementById(eleId);
    let all_chips = selected_option_ele.children;
    let removed_chips = Array.from(all_chips).filter((x) => x.getAttribute("token_name") != chipText);
    let remove_chips_html = removed_chips.map((element) => element.outerHTML).join("");
    // let chip = this.getChip(eleId,chipText);
    // let selected_option = selected_option_ele.innerHTML;
    // selected_option += chip;
    selected_option_ele.innerHTML = remove_chips_html;
  }

  async addChipInUIbySessionStorage(containerTokenElementId, sessionStorageKey) {
    console.log("not trying to add chip in ui by session storage");
    console.log("addChipInUI by SessionStorage called ");
    console.log("sessionStorage key ::", sessionStorageKey);
    await this.getDeduplicateTokenInSessionStorage(sessionStorageKey);
    let client_query_obj = new EditJDComponents().getCurrentJobClientQueryObject();
    if (sessionStorageKey == "edit_jd_company_tokens") {
      let tokenContainer = document.getElementById(containerTokenElementId);
      let data = client_query_obj?.company_name?.length > 0 ? client_query_obj.company_name : [];
      let oldTokens = "";
      data.forEach((obj) => {
        let newGenerateToken = this.getChip(containerTokenElementId, obj.name);
        oldTokens += newGenerateToken;
      });
      tokenContainer.innerHTML = oldTokens;
    } else if (sessionStorageKey == "edit_jd_location_tokens") {
      let tokenContainer = document.getElementById(containerTokenElementId);
      let data = client_query_obj?.locations?.length > 0 ? client_query_obj.locations : [];
      let oldTokens = "";
      data.forEach((obj) => {
        let newGenerateToken = this.getChip(containerTokenElementId, obj.name);
        oldTokens += newGenerateToken;
      });
      tokenContainer.innerHTML = oldTokens;
    }
  }
  getDeduplicateTokenInSessionStorage(sessionStorageKey) {
    console.log("get Deduplicate Token In Session storage called");
    return new Promise(async (resolve, reject) => {
      let client_query_obj = new EditJDComponents().getCurrentJobClientQueryObject();
      console.log("client_query_obj");
      console.log(client_query_obj);
      if (sessionStorageKey == "edit_jd_company_tokens") {
        let data = client_query_obj?.company_name?.length > 0 ? client_query_obj.company_name : [];
        let data2 = client_query_obj?.company_id?.length > 0 ? client_query_obj.company_id : [];
        const idMap = new Map();
        data.forEach((obj) => {
          idMap.set(obj.name, obj);
        });
        const idMap2 = new Map();
        data2.forEach((obj) => {
          idMap2.set(obj.name, obj);
        });
        client_query_obj.company_id = Array.from(idMap2.values());
        client_query_obj.company_name = Array.from(idMap.values());
      } else if (sessionStorageKey == "edit_jd_location_tokens") {
        let data = client_query_obj?.locations?.length > 0 ? client_query_obj.locations : [];
        const idMap = new Map();
        data.forEach((obj) => {
          idMap.set(obj.name, obj);
        });
        client_query_obj.locations = Array.from(idMap.values());
      }
      await new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);
      resolve();
    });
  }

  isChipExists(id, chipText) {
    console.log("Chip id:", id, "hcip text:", chipText);
    let existingChip = document.querySelector(`[token_name="${chipText}"]`);
    console.log("Existing chipp::", existingChip);
    return existingChip !== null;
  }

  getChip(id, chipText) {
    let chip = document.getElementById("text_token_without_minus").innerHTML;
    let unique_val = id + "_" + chipText.replace(" ", "_");
    chip = chip
      .replace(/{token_name}/g, chipText)
      .replace(/{token_for}/g, id)
      .replace(/{dropdown_class_name_}/g, unique_val)
      .replace("border-left: none;border-right: none;", "border-left: none;border-right: block;");

    // let chip = template.replace(/{token_name}/g, chipText); // Use regex with 'g' flag for global replacement
    // chip = chip.replace(/{dropdown_class_name_}/g, unique_val);

    return chip;

    //     return `<div id="${id}_${chipText}" class="alert alert-custom" style="position: relative;" data-field="${chipText}">
    //     ${chipText}
    //     <span style="top: 0; right: 0;font-size: 12pt;">
    //         <button type="button" class="close" style= "margin-top: 4px;" data-dismiss="alert">
    //             <span aria-hidden="false">&times;</span>
    //         </button>
    //     </span>
    // </div>`
  }

  getAllChipValues(chipContainerId) {
    let chipsContainer = document.getElementById(chipContainerId);
    let chipElements = chipsContainer.querySelectorAll(".alert-custom[data-field]");
    let chipValues = Array.from(chipElements).map((chip) => chip.getAttribute("data-field"));
    return chipValues;
  }

  getAllSelectedFields(chipContainerId) {
    console.log("chip containt id", chipContainerId);
    let chipsContainer = document.getElementById(chipContainerId);
    console.log("This is the chips container", chipsContainer);
    let chipValues = Array.from(chipsContainer.children).map((chip) => chip.getAttribute("token_name"));
    console.log(chipValues);
    return chipValues;
  }
}

class EditJDComponents {
  // setCurrentJobClientQueryObject(client_query_obj){
  //     console.log();
  //     let current_job = JSON.parse(sessionStorage["editJdDetails"])
  //     current_job.client_query_obj = client_query_obj
  //     sessionStorage['editJdDetails'] = JSON.stringify(current_job)
  //     let all_jobs = JSON.parse(sessionStorage["edit_jd_all_jobs"])
  //     let job = all_jobs.find(job => job.job_id == current_job.job_id);
  //     job.client_query_obj = client_query_obj
  //     console.log("updateed job obj");
  //     console.log(job);
  //     sessionStorage["edit_jd_all_jobs"] = JSON.stringify(all_jobs)
  // }
  // generateHTMLForCountry(div_id) {
  //     var countries_arr = JSON.parse(sessionStorage['location_analytics'])

  //     if (!countries_arr.length){
  //         sole.error("error in func : generateHTMLForCountry, countries_arr is not found")
  //         return
  //     }
  //     let htmlcode =
  //     `<div class="dropdown position-static" id="${div_id}">
  //         <button id="btn_${div_id}" class="btn dropdown-toggle" type="button"style="font-size:10pt;background-color:white; background-color:white; color:black; border:1px solid rgb(210,210,210);" data-toggle="dropdown" aria-haspopup="true" data-boundary="" aria-expanded="false"> Select Country
  //         </button>
  //         <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="font-size: 10pt; max-height: 50%; overflow-y: auto; position: absolute; transform: translate3d(39px, 287px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">`

  //         countries_arr.forEach((country) => {
  //             let country_title = country.replace(/\s+/g, "_").toLowerCase();
  //             htmlcode += `<a class="dropdown-item" style="cursor:pointer" onclick="new EditJDComponents().onClickCoutryOption(this)" id="${div_id}-${country_title}" data-field="${country}" >${country}</a>`
  //         });

  //     htmlcode += `</div></div>`
  //     return htmlcode;

  // }
  // onClickCoutryOption(element){
  //     var SelectedCountryName = element.getAttribute('data-field');
  //     var id = element.getAttribute('id');
  //     let all_data = [...id.split("-")];
  //     console.log(SelectedCountryName);
  //     let show_el = document.getElementById(`btn_${all_data[0]}`);
  //     show_el.innerHTML = SelectedCountryName
  //     let edit_jd_region = document.getElementById("modal_edit_jd_location_region_master")
  //     edit_jd_region.innerHTML = new EditJDComponents().generateHTMLForRegion('edit_jd_region',SelectedCountryName)
  // }
  // generateHTMLForRegion(div_id,SelectedCountryName) {
  //     var region_arr = new DrawOrgCharts().getRegionsFromCountry(SelectedCountryName)
  //     if (!region_arr.length){
  //         console.log("error in func : generateHTMLForRegion, region_arr is not found")
  //         return
  //     }
  //     let htmlcode =
  //     `<div class="dropdown position-static" id="${div_id}">
  //         <button id="btn_${div_id}" class="btn dropdown-toggle" type="button"style="font-size:10pt;background-color:white; background-color:white; color:black; border:1px solid rgb(210,210,210);" data-toggle="dropdown" aria-haspopup="true" data-boundary="" aria-expanded="false"> Select Region
  //         </button>
  //         <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="font-size: 10pt; max-height: 50%; overflow-y: auto; position: absolute; transform: translate3d(39px, 287px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">`

  //         region_arr.forEach((region) => {
  //             let title = region.replace(/\s+/g, "_").toLowerCase();
  //             htmlcode += `<a class="dropdown-item" style="cursor:pointer" onclick="new EditJDComponents().onClickRegionOption(this)" id="${div_id}-${title}" data-field="${region+","+SelectedCountryName}" >${region}</a>`
  //         });

  //     htmlcode += `</div></div>`
  //     return htmlcode;
  // }
  // onClickRegionOption(element){
  //     var selectedRegionNcountry = element.getAttribute('data-field');
  //     let regionContry = [...selectedRegionNcountry.split(",")];
  //     var id = element.getAttribute('id');
  //     let all_data = [...id.split("-")];
  //     console.log(regionContry);
  //     let show_el = document.getElementById(`btn_${all_data[0]}`);
  //     show_el.innerHTML = regionContry[0]
  //     let edit_jd_locality = document.getElementById("modal_edit_jd_location_locality_master")
  //     edit_jd_locality.innerHTML = new EditJDComponents().generateHTMLForLocality('edit_jd_locality',regionContry[0],regionContry[1])
  // }
  // generateHTMLForLocality(div_id,regionName,countryName) {
  //     var locality_arr = new DrawOrgCharts().getLocalitiesfromCountryAndRegion(countryName, regionName)
  //     if (!locality_arr.length){
  //         console.log("error in func : generateHTMLForLocality, locality_arr is not found")
  //         return
  //     }
  //     let htmlcode =
  //     `<div class="dropdown position-static" id="${div_id}">
  //         <button id="btn_${div_id}" class="btn dropdown-toggle" type="button"style="font-size:10pt;background-color:white; background-color:white; color:black; border:1px solid rgb(210,210,210);" data-toggle="dropdown" aria-haspopup="true" data-boundary="" aria-expanded="false"> Select Locality
  //         </button>
  //         <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="font-size: 10pt; max-height: 50%; overflow-y: auto; position: absolute; transform: translate3d(39px, 287px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">`

  //         locality_arr.forEach((locality) => {
  //             let title = locality.replace(/\s+/g, "_").toLowerCase();
  //             htmlcode += `<a class="dropdown-item" style="cursor:pointer" onclick="new EditJDComponents().onClickLocalityOption(this)" id="${div_id}-${title}" data-field="${locality}" >${locality}</a>`
  //         });

  //     htmlcode += `</div></div>`
  //     return htmlcode;
  // }
  // onClickLocalityOption(element){
  //     var selectedLocality = element.getAttribute('data-field');
  //     var id = element.getAttribute('id');
  //     let all_data = [...id.split("-")];
  //     console.log(selectedLocality);
  //     let show_el = document.getElementById(`btn_${all_data[0]}`);
  //     show_el.innerHTML = selectedLocality
  // }

  // onClickLocationSearch(element){
  //     // let user_val = element.value
  //     // let input_field_obj = {"element_focussed":"locations" ,"user_input":user_val}
  //     // new SearchBarLoadersDropdowns().getDataLoadAutocompleteDropdownCustom(input_field_obj)

  // }
  // onKeypressManageCompany(event){
  //     let edit_jd_gpt_company_chips = document.getElementById('edit_jd_gpt_company_chips')
  //     edit_jd_gpt_company_chips.innerHTML = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/><br><br><span style="font-size:10pt">Searching your data...</span></div>'
  //     if (event.keyCode === 13) {
  //         new EditJDComponents().getGPTResponseFromBackendOnInput(event.target);
  //     }
  //     if(event?.target?.value?.length > 3){
  //         new EditJDComponents().onKeypressSearchCompany(event.target);
  //     }
  // }
  // onKeypressSearchCompany(element){
  //     // let user_val = element.value
  //     // let input_field_obj = {"element_focussed":"company_name" ,"user_input":user_val}
  //     // sessionStorage["new_input_text_token"] = user_val
  //     // new SearchBarLoadersDropdowns().getDataLoadAutocompleteDropdownCustom(input_field_obj)
  // }

  // =====================================================================================================================================
  onBlurHideDropdown(element) {
    let dropdown_id = element.getAttribute("id");

    if (dropdown_id == "edit_jd_company_name") {
      document.getElementById("edit_jd_company_name").value = "";
    }
    if (dropdown_id == "edit_jd_locations") {
      document.getElementById("edit_jd_locations").value = "";
    }
  }
  setClientQueryObjectToCurrentJob(obj) {
    return new Promise(async (resolve, reject) => {
      let current_job = JSON.parse(sessionStorage["current_job"]);
      current_job.client_query_obj = obj;
      sessionStorage["current_job"] = JSON.stringify(current_job);
      await this.setCurrentJobObjectToAlljobsObjectInSessionStorage();
      resolve();
    });
  }
  setCurrentJobObjectToAlljobsObjectInSessionStorage() {
    return new Promise((resolve, reject) => {
      let current_job = JSON.parse(sessionStorage["current_job"]);
      let all_jobs = JSON.parse(sessionStorage["all_jobs_details"]);

      const index = all_jobs.findIndex((job) => job.job_id == current_job.job_id); // Find the index

      console.log("old job_object", all_jobs[index]);
      console.log("new update job_object", current_job);
      all_jobs[index] = current_job;
      sessionStorage["all_jobs_details"] = JSON.stringify(all_jobs);
      resolve();
    });
  }
  getEditJdModalValues() {
    let values = {};
    let function_root = document.getElementById("btn_edit_jd_function_root")?.innerText || "";
    values["function_root"] = function_root && function_root.trim() != "Select Function".trim() ? function_root : "";
    let sub_function = document.getElementById("btn_edit_jd_sub_function")?.innerText;
    values["sub_function"] = sub_function && sub_function.trim() != "Select Sub Function".trim() ? sub_function : "";
    let grades = document.getElementById("btn_edit_jd_grades")?.innerText;
    values["grades"] = grades && grades.trim() != "Siniorty".trim() ? grades : "";
    return values;
  }
  getCurrentJobClientQueryObject() {
    let current_job = JSON.parse(sessionStorage["current_job"]);
    return current_job?.client_query_obj || [];
  }
  async updateSessionStorageValueOnChange() {
    let client_query_obj = this.getCurrentJobClientQueryObject();
    console.log(" this is getCurrentJob ClientQueryObject");
    console.log(client_query_obj);

    let values = new EditJDComponents().getEditJdModalValues();

    // set all modal DD values to client_query object
    if (values?.function_root && values?.function_root != "") {
      client_query_obj.function_root = [{ exclude: false, name: values?.function_root }];
    }
    if (values?.sub_function && values?.sub_function != "") {
      client_query_obj.functions = [{ exclude: false, name: values?.sub_function }];
    }
    if (values?.grades && values?.grades != "") {
      client_query_obj.grades = [{ exclude: false, name: values?.grades }];
    }
    await new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);
  }
  async onLoadEditJdModal(current_job) {
    let client_query_obj = current_job.client_query_obj;
    // company search and tokens
    document.getElementById("edit_jd_company_search_gpt_textarea").value = "";
    document.getElementById("gpt_search_loading").innerHTML = "";
    document.getElementById("edit_jd_company_name_auto_complete_input").value = "";
    document.getElementById("dropdown_list_company_name").innerHTML = "";
    document.getElementById("edit_jd_company_tokens").innerHTML = "";

    // location search and token
    document.getElementById("edit_jd_locations_auto_complete_input").value = "";
    document.getElementById("dropdown_list_locations").innerHTML = "";
    document.getElementById("edit_jd_location_tokens").innerHTML = "";

    // set modal head line
    let headline = document.getElementById("headline_modal_edit_jd");
    headline.innerHTML = `<h5><strong>Edit JD : ${current_job.job_name || ""}</strong></h5>`;

    // set and bind function root dropdown, sub function
    new EditJDComponents().generateHTMLForFunctionRoot();
    // below function will called from generateHTMLForFunctionRoot()
    // new EditJDComponents().generateHTMLForSubFunction('')

    document.getElementById("btn_edit_jd_grades").innerText = "Select Seniority";

    if (client_query_obj.length > 0 || typeof client_query_obj == "object") {
      if (client_query_obj.function_root.length > 0) {
        document.getElementById("btn_edit_jd_function_root").innerText = client_query_obj.function_root[0].name;
        new EditJDComponents().generateHTMLForSubFunction(client_query_obj.function_root[0].name);
      }
      if (client_query_obj.functions.length > 0) {
        document.getElementById("btn_edit_jd_sub_function").innerText = client_query_obj.functions[0].name;
      }
      if (client_query_obj.grades.length > 0) {
        document.getElementById("btn_edit_jd_grades").innerText = client_query_obj.grades[0].name;
      }
    }
    await new Components().addChipInUIbySessionStorage("edit_jd_company_tokens", "edit_jd_company_tokens");
    await new Components().addChipInUIbySessionStorage("edit_jd_location_tokens", "edit_jd_location_tokens");
  }
  generateHTMLForFunctionRoot() {
    const functions_tree_element = JSON.parse(document.getElementById("functions_tree").getAttribute("data-row"));
    const dataArray = !!functions_tree_element?.tree_obj ? [...functions_tree_element.tree_obj] : [];

    let client_query_obj = this.getCurrentJobClientQueryObject();
    let defaultSelection = client_query_obj.hasOwnProperty("function_root") && client_query_obj?.function_root.lenght > 0 ? client_query_obj.function_root[0].name : "Select Function";

    if (!dataArray.length) {
      console.log("error in func : generateDropdownForFunctionTree, functions_tree is not found");
      return;
    }
    let containerId = "edit_jd_function_root_container";
    let elementId = "edit_jd_function_root";

    let htmlcode = `<div class="dropdown position-static" id="${elementId}">
            <button id="btn_${elementId}" class="btn dropdown-toggle" type="button"style="font-size:10pt;background-color:white; background-color:white; color:black; border:1px solid rgb(210,210,210);" data-toggle="dropdown" aria-haspopup="true" data-boundary="" aria-expanded="false">${defaultSelection}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="font-size: 10pt; max-height: 50%; overflow-y: auto; position: absolute; transform: translate3d(39px, 287px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">`;

    try {
      dataArray.forEach((mainItem) => {
        let title = mainItem.title.replace(/\s+/g, "_").toLowerCase();
        htmlcode += `<a class="dropdown-item" style="cursor:pointer" onclick="new EditJDComponents().onSelectFunctionRootOption(this)" id="${elementId}-${mainItem.id}-${title}" data-field="${mainItem.title}" >${mainItem.title}</a>`;
      });
    } catch (error) {
      console.log("error in generateHTMLForFunctionRoot ::", error);
    }

    htmlcode += `</div></div>`;

    // bind dropdown with container
    document.getElementById(containerId).innerHTML = htmlcode;
    if (!!defaultSelection) {
      new EditJDComponents().generateHTMLForSubFunction(defaultSelection);
    }

    return true;
  }
  generateHTMLForSubFunction(functionRoot = "") {
    const functions_tree_element = JSON.parse(document.getElementById("functions_tree").getAttribute("data-row"));
    const dataArray = !!functions_tree_element?.tree_obj ? [...functions_tree_element.tree_obj] : [];

    if (!dataArray.length) {
      console.log("error in func : generateDropdownForFunctionTree, functions_tree is not found");
      return;
    }
    let containerId = "edit_jd_sub_function_container";
    let elementId = "edit_jd_sub_function";

    let client_query_obj = this.getCurrentJobClientQueryObject();

    let defaultSelection = client_query_obj.hasOwnProperty("functions") && client_query_obj?.functions.lenght > 0 ? client_query_obj.functions[0].name : "Select Sub Function";

    let htmlcode = `<div class="dropdown position-static" id="${elementId}">
            <button id="btn_${elementId}" class="btn dropdown-toggle" type="button"style="font-size:10pt;background-color:white; background-color:white; color:black; border:1px solid rgb(210,210,210);" data-toggle="dropdown" aria-haspopup="true" data-boundary="" aria-expanded="false"> ${defaultSelection}
            </button>
            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton" style="font-size: 10pt; max-height: 50%; overflow-y: auto; position: absolute; transform: translate3d(39px, 287px, 0px); top: 0px; left: 0px; will-change: transform;" x-placement="bottom-start">`;

    try {
      dataArray.every((mainItem) => {
        if (mainItem.title == functionRoot) {
          mainItem.subs.forEach((subItem) => {
            let title = subItem.title.replace(/\s+/g, "_").toLowerCase();
            htmlcode += `<a class="dropdown-item" style="cursor:pointer" onclick="new EditJDComponents().onSelectSubFunctionOption(this)" id="${elementId}-${subItem.id}-${title}" data-field="${subItem.title}" >${subItem.title}</a>`;
          });
          return false;
        }
        return true;
      });
    } catch (error) {
      console.log("error in generateHTMLForFunctionRoot ::", error);
    }

    htmlcode += `</div></div>`;

    // bind dropdown with container
    document.getElementById(containerId).innerHTML = htmlcode;

    return true;
  }
  onSelectFunctionRootOption(element) {
    // user selection value
    let selectedValue = element.getAttribute("data-field");
    console.log("onSelect Function Option", selectedValue);

    // to set selection value in UI
    let id = element.getAttribute("id");
    let all_data = [...id.split("-")];
    let dropdownButton = document.getElementById(`btn_${all_data[0]}`);
    dropdownButton.innerHTML = selectedValue;

    // set value in sessionstorage
    this.updateSessionStorageValueOnChange();

    // based on function root selection bind sub function
    new EditJDComponents().generateHTMLForSubFunction(selectedValue);
  }
  onSelectSubFunctionOption(element) {
    // user selected value
    let selectedValue = element.getAttribute("data-field");
    console.log("onClick Sub Function Option", selectedValue);

    // to set selection value in UI
    let id = element.getAttribute("id");
    let all_data = [...id.split("-")];
    let dropdownButton = document.getElementById(`btn_${all_data[0]}`);
    dropdownButton.innerHTML = selectedValue;

    // set value in sessionstorage
    this.updateSessionStorageValueOnChange();
  }
  onSelectionGradesOption(element) {
    // user selected value
    let selectedValue = element.getAttribute("data-field");
    console.log("onClick Grades Option", selectedValue);

    // to set selection value in UI
    let id = element.getAttribute("id");
    let all_data = [...id.split("-")];
    let dropdownButton = document.getElementById(`btn_${all_data[0]}`);
    dropdownButton.innerHTML = selectedValue;

    // set value in sessionstorage
    this.updateSessionStorageValueOnChange();
  }
  onKeypressUpdateInputAndShowDropdown(element) {
    let input_val = element.value;
    let dropdown_id = element.getAttribute("id");
    let input_field_obj = { element_focussed: "", user_input: "" };

    sessionStorage["onKeypressInput"] = input_val;

    if (dropdown_id == "edit_jd_company_name_auto_complete_input") {
      input_field_obj.element_focussed = "company_name";
      input_field_obj.user_input = input_val;
    }
    if (dropdown_id == "edit_jd_locations_auto_complete_input") {
      input_field_obj.element_focussed = "locations";
      input_field_obj.user_input = input_val;
    }

    // setime to sleep and then call an ajax function that gets data and opens up the damn dropdown
    setTimeout(new SearchBarLoadersDropdowns().getDataLoadAutocompleteDropdownCustom(input_field_obj), 1000);
  }
  async onClickCustomDropdownElementPerformAction(event) {
    console.log("onClick Custom Dropdown Element Perform Action called");
    let element = event.target;
    let element_focussed = event.currentTarget.getAttribute("data-element-focussed");
    let data_value = event.currentTarget.getAttribute("data-value");
    console.log(element_focussed);
    console.log(data_value);
    let client_query_obj = new EditJDComponents().getCurrentJobClientQueryObject();

    if (element_focussed == "company_name") {
      let company_id = event.currentTarget.children[0].children[0].getAttribute("company_id");

      let companyId = { name: company_id, exclude: false };
      let companyName = { exclude: false, name: data_value };

      let companyNameData = client_query_obj?.company_name?.length > 0 ? client_query_obj.company_name : [];
      let companyIdData = client_query_obj?.company_id?.length > 0 ? client_query_obj.company_id : [];

      companyNameData.push(companyName);
      companyIdData.push(companyId);

      console.log({ companyIdData });
      console.log({ companyNameData });

      client_query_obj.company_id = companyIdData;
      client_query_obj.company_name = companyNameData;

      await new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);

      await new Components().addChipInUIbySessionStorage("edit_jd_company_tokens", "edit_jd_company_tokens");
      document.getElementById("dropdown_list_company_name").innerHTML = "";
      document.getElementById("edit_jd_company_name_auto_complete_input").value = "";
    } else if (element_focussed == "locations") {
      let location = { exclude: false, name: data_value };
      let locationsData = client_query_obj?.locations?.length > 0 ? client_query_obj.locations : [];
      locationsData.push(location);
      console.log({ locationsData });
      client_query_obj.locations = locationsData;

      await new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);
      await new Components().addChipInUIbySessionStorage("edit_jd_location_tokens", "edit_jd_location_tokens");

      document.getElementById("dropdown_list_locations").innerHTML = "";
      document.getElementById("edit_jd_locations_auto_complete_input").value = "";
    }
  }
  getGPTResponseFromBackendOnInput(element) {
    let input_value = element.value;
    let client_query_obj = {};
    client_query_obj["raw_string_query_input"] = input_value;
    document.getElementById("gpt_search_loading").innerHTML = '<div style="width:100%;text-align:center; padding:40px"><img style="width:30px" src="/static/img/new_loading2.gif"/></div>';

    let data_obj = JSON.stringify({
      user_id: localStorage["user_id"],
      visitor_fp: sessionStorage["visitor_fp"],
      client_query_obj,
    });
    $.ajax({
      url: "/gpt_company_name",
      type: "POST",
      headers: { "Content-Type": "application/json" },
      data: data_obj,
      error: function (xhr, status) {
        let error_status = xhr.status;
        if (error_status == 599) {
          new PageContents().tokenExpireAction();
        }
        if (error_status == 500) {
          console.log("There has been an error in the gpt_company_name");
        }
        document.getElementById("gpt_search_loading").innerHTML = "something went wrong!!! try after some time";
      },
    }).done(function (data) {
      console.log("AJAX to hit for edit_jd ");
      console.log("This is the AJAX response ", data);
      element.value = "";
      document.getElementById("gpt_search_loading").innerHTML = "";
      if (data?.status == "success") {
        let result = data?.data.length > 0 ? [...data?.data] : [];

        let companyIdData = result.map((x) => {
          return { name: x.job_company_id, exclude: false };
        });
        let companyName = result.map((x) => {
          return { name: x.job_company_name, exclude: false };
        });

        let client_query_obj = new EditJDComponents().getCurrentJobClientQueryObject();
        let company_name_data = client_query_obj?.company_name?.length > 0 ? client_query_obj.company_name : [];
        let company_id_data = client_query_obj?.company_id?.length > 0 ? client_query_obj.company_id : [];

        let final_company_nm = [...companyName, ...company_name_data];
        let final_company_id = [...companyIdData, ...company_id_data];

        client_query_obj.company_id = [...final_company_id];
        client_query_obj.company_name = [...final_company_nm];

        new EditJDComponents().setClientQueryObjectToCurrentJob(client_query_obj);
        new Components().addChipInUIbySessionStorage("edit_jd_company_tokens", "edit_jd_company_tokens");
      }
    });
  }
}

export { generalMessagePopUpShow, generalMessagePopUpHide, takeRefreshUserDataandLoadDashboardPage, loadCandidateSourcesPages, contactDetailsReplaceElement, Components, EditJDComponents };
if (typeof window !== 'undefined') {
  window.generalMessagePopUpShow = generalMessagePopUpShow;
  window.generalMessagePopUpHide = generalMessagePopUpHide;
  window.takeRefreshUserDataandLoadDashboardPage = takeRefreshUserDataandLoadDashboardPage;
  window.loadCandidateSourcesPages = loadCandidateSourcesPages;
  window.contactDetailsReplaceElement = contactDetailsReplaceElement;
  window.Components = Components;
  window.EditJDComponents = EditJDComponents;
}
